import { render, staticRenderFns } from "./BulksModal.vue?vue&type=template&id=76aba9dc&"
import script from "./BulksModal.vue?vue&type=script&lang=js&"
export * from "./BulksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports